import React from 'react';
import MainPage from '../components/MainPage.react';

export default class Support extends React.Component {
  render(){
    return (<MainPage><h1>Support</h1></MainPage>);
  }
}
